<script>
import BestOdds from '../BestOdds/BestOdds.vue';

export default {
  name: 'EventSelection',
  components: {
    BestOdds,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    eventId: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    number: {
      type: Number,
      default: 0,
    },
    barrier: {
      type: Number,
      default: 0,
    },
    competitorUrl: {
      type: String,
      default: '',
    },
    jockeyNameShort: {
      type: String,
      default: '',
    },
    jockeyUrl: {
      type: String,
      default: '',
    },
    jockeyImageUrl: {
      type: String,
      default: '',
    },
    trainerNameShort: {
      type: String,
      default: '',
    },
    trainerUrl: {
      type: String,
      default: '',
    },
    isShortlisted: {
      type: Boolean,
      default: false,
    },
    odds: {
      type: Object,
      default: () => {},
    },
    weight: {
      type: Number,
      default: 0,
    },
    lastSixFigure: {
      type: String,
      default: '',
    },
  },
  data: function() {
    return {
      shortlisted: this.isShortlisted,
    };
  },
  methods: {
    show: function() {
      this.$emit('show', this.id);
    },
    shortlist: function() {
      this.$emit('shortlistSelection', this.id, this.shortlisted ? 'remove' : 'add');
      this.shortlisted = !this.shortlisted;
    },
  },
};
</script>
<template>
  <li class="form-result">
    <img v-if="jockeyImageUrl" 
         :src="jockeyImageUrl" 
         :alt="name" 
         class="form-result__jockey" >
    <div class="form-result__competitor form-result__competitor__mobile" @click="show">
      <h4
        class="form-result__competitor-name"
      >{{ number ? number + '.' : '' }} {{ name }} {{ barrier ? '(' + barrier + ')' : '' }}</h4>
      <dl class="form-result__competitor-stats">
        <div v-if="weight">
          <dt class="form-result__competitor-stats-jockey"></dt>
          <dd class="form-result__competitor-stats-jockey">{{ weight }}kg</dd>
        </div>
        <div v-if="jockeyNameShort">
          <dt class="form-result__competitor-stats-jockey">J</dt>
          <dd class="form-result__competitor-stats-jockey">{{ jockeyNameShort }}</dd>
        </div>
      </dl>
      <dl class="form-result__competitor-stats">
        <div v-if="lastSixFigure">
          <dt class="form-result__competitor-stats-jockey"></dt>
          <dd class="form-result__competitor-stats-jockey">{{ lastSixFigure }}</dd>
        </div>
        <div v-if="trainerNameShort">
          <dt class="form-result__competitor-stats-trainer">T</dt>
          <dd class="form-result__competitor-stats-trainer">{{ trainerNameShort }}</dd>
        </div>
      </dl>
    </div>
    <div class="form-result__competitor form-result__competitor__desktop">
      <a :href="competitorUrl" target="_blank">
        <h4
          class="form-result__competitor-name"
        >{{ number ? number + '.' : '' }} {{ name }} {{ barrier ? '(' + barrier + ')' : '' }}</h4>
      </a>
      <dl class="form-result__competitor-stats">
        <div v-if="weight">
          <dt class="form-result__competitor-stats-jockey"></dt>
          <dd class="form-result__competitor-stats-jockey">{{ weight }}kg</dd>
        </div>

        <a :href="trainerUrl" target="_blank">
          <div v-if="jockeyNameShort">
            <dt class="form-result__competitor-stats-jockey">J</dt>
            <dd class="form-result__competitor-stats-jockey">{{ jockeyNameShort }}</dd>
          </div>
        </a>
      </dl>
      <dl class="form-result__competitor-stats">
        <div v-if="lastSixFigure">
          <dt class="form-result__competitor-stats-jockey"></dt>
          <dd class="form-result__competitor-stats-jockey">{{ lastSixFigure }}</dd>
        </div>
        <a :href="trainerUrl" target="_blank">
          <div v-if="trainerNameShort">
            <dt class="form-result__competitor-stats-trainer">T</dt>
            <dd class="form-result__competitor-stats-trainer">{{ trainerNameShort }}</dd>
          </div>
        </a>
      </dl>
    </div>
    <div class="form-result__odds">
      <div class="form-result__odds-full">
        <BestOdds :selection-id="id" :odds="odds" display="movement" />
      </div>
      <div class="form-result__odds-compact">
        <BestOdds :selection-id="id" :odds="odds" display="movement" />
        <button :class="['quickbet-button__watch', { shortlisted }]" @click="shortlist">Watch</button>
      </div>
    </div>
  </li>
</template>
